import {
    CREATE_COMPACTING_INWARD_DETAILS_FAILURE,
    CREATE_COMPACTING_INWARD_DETAILS_REQUEST,
    CREATE_COMPACTING_INWARD_DETAILS_SUCCESS,
    CREATE_USER_FORM_COMPACTING_INWARD_DETAILS,
    DELETE_COMPACTING_INWARD_DETAILS_FAILURE,
    DELETE_COMPACTING_INWARD_DETAILS_REQUEST,
    DELETE_COMPACTING_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS,
    FETCH_COMPACTING_INWARD_DETAILS_FAILURE,
    FETCH_COMPACTING_INWARD_DETAILS_REQUEST,
    FETCH_COMPACTING_INWARD_DETAILS_SUCCESS,
    COMPACTING_INWARD_DETAILS_USERFORM_RESET,
    UPDATE_COMPACTING_INWARD_DETAILS_FAILURE,
    UPDATE_COMPACTING_INWARD_DETAILS_REQUEST,
    UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS,
    FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST,
    FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS,
    FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS,
    FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE,
    FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST,
    COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED
} from './compactingInwardDetails.actionsType';

export const COMPACTING_DIVISION_INWARD_DETAILS = 'compactingDivisionInwardDetails';

let initialState = {
    loading: false,
    compactingInwardDetailsById: [],
    compactingInwardDetails: [],
    previousGetList: [],
    isDCDetailDisabled: false,
    compactingInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0,
        fldReceivingRolls: 0,
        fldProcessLoss: 0,
        fldIsProcessLoss: false,
        fldFKPendingWeight: 0


    },
    selectedCompactingInwardDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let compactingDivisionInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_COMPACTING_INWARD_DETAILS_REQUEST:
        case FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST:
        case FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST:
        case CREATE_COMPACTING_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST:
        case UPDATE_COMPACTING_INWARD_DETAILS_REQUEST:
        case DELETE_COMPACTING_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingInwardDetails: updatePayload
            };
        case FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsById: updatePayload
            };
        case FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.COII
            };

        case CREATE_COMPACTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isDCDetailDisabled: false
            };
        case FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCompactingInwardDetails: updatePayload,
                compactingInwardDetailsForm: {
                    ...updatePayload
                }
            };
        case UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCompactingInwardDetails: {},
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isDCDetailDisabled: false
            };
        case DELETE_COMPACTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isDCDetailDisabled: false,
                selectedCompactingInwardDetails: {}
            };
        case COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED:
            return {
                ...state,
                isDCDetailDisabled: payload
            };
        case FETCH_COMPACTING_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE:
        case FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE:
        case CREATE_COMPACTING_INWARD_DETAILS_FAILURE:
        case UPDATE_COMPACTING_INWARD_DETAILS_FAILURE:
        case DELETE_COMPACTING_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_INWARD_DETAILS:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsForm: {
                    ...state.compactingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case COMPACTING_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false,
                    fldStyleNumber:'',
                    fldSalesOrderNo:'',
                    fldFabricname:'',
                    fldFabricGroup:'',
                    fldYarnCounts:'',
                    fldColour:'',
                    fldColourShade:'',
                    FldInwardDia:'',
                    fldRequiredDia:'',
                    fldGSM:'',
                    fldAfterCompactingGSM:'',
                    fldReceivingRolls:'',
                    fldQuantity:'',
                    fldReceivingRolls:'',
                    fldDispatchNoofRolls:'',
                    fldDispatchWeightinKg:'',
                },
                isDCDetailDisabled: false,
                selectedCompactingInwardDetails: {}
            };
        default:
            return state;
    }
};
